import * as React from 'react';
import {
    Box,
    Button,
} from '@mui/material';
import PlanNamingFields from '../../components/PlanNamingFields';
import { buildPlanFileName } from '../../utils/planNamingUtils';

function ValidationFileName({
    companyId,
    setJobName,
    setAreaName,
    setFloorName,
    handleUpload,
    setFileName,
    jobName = '',
    areaName = '',
    floorName = '',
    file,
}) {
  /// file requires functional name for verification and sale this componant will assign the new name to the file
    return (
        <Box p={3} sx={{ width: '100%', height: '100%', justifyContent: 'center' }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                flexDirection: 'column'
            }}>
                <h2>File Name</h2>
                <h4>{file?.info?.name}</h4>
                <br />
                <PlanNamingFields
                    jobName={jobName}
                    floorName={floorName}
                    areaName={areaName}
                    onJobNameChange={setJobName}
                    onFloorNameChange={setFloorName}
                    onAreaNameChange={setAreaName}
                    onFileNameSync={(job, floor, area) => {
                        const built = buildPlanFileName({
                            jobName: job,
                            floorName: floor,
                            areaName: area,
                            extension: '.txt',
                        });
                        if (built) {
                            setFileName(built);
                        }
                    }}
                    disabled={companyId === undefined}
                />
                <Button sx={{ width: '50%', margin: 5 }} disabled={companyId === undefined} variant="contained" onClick={handleUpload}>Update File Name</Button>
            </Box>
        </Box>
    );
}

export default ValidationFileName;
